import * as angular from 'angular';
import template from './commonReportLocationRow.tpl.html';

export default angular.module('aps.directive.commonReportLocationRow', [])
  .directive('apsCommonReportLocationRow', commonReportLocationRowDef)
  .name;

function commonReportLocationRowDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    scope: {
      vm: '='
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/reports/commonReportLocationRow.directive.ts